import { TalkhattabatConversationType } from "../../../../Types";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Header from "./Header";
import SideBulkActions from "./SideBulkActions";
import InputFields from "./input-fields";

const BulkMessages = withLiteObserverAndTheme<{
  conversationType: TalkhattabatConversationType;
}>((props) => {
  const { conversationType } = props;

  return (
    <ET3Div
      width={1510}
      height={0}
      alignItems={"flex-end"}
      fDirection={"column"}
      style={{}}
      color={""}
      justifyContent={"flex-start"}
      withShadow={false}
      isExtendable={true}
      isScrollable={false}
      onClick={() => {}}
    >
      <Header />
      <ET3Div
        width={1510}
        height={0}
        alignItems={"center"}
        fDirection={"row"}
        style={{}}
        color={""}
        justifyContent={"flex-start"}
        withShadow={false}
        isExtendable={true}
        isScrollable={false}
        onClick={() => {}}
      >
        <InputFields conversationType={conversationType} />
        <SideBulkActions conversationType={conversationType} />
      </ET3Div>
    </ET3Div>
  );
});

export default BulkMessages;
